module.exports = "/_next/static/images/68a18f8f7f0798a3c4d912a8148e9ace-hero-lg.jpg";